import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import { ChartBarIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

interface AnalysisSubmenuProps {
  collapsed: boolean;
  onMobileClose?: () => void;
}

const items = [
  { path: '/analysis/quotes-outstanding', label: 'Quotes Outstanding' },
  { path: '/analysis/carrier-aggregates', label: 'Carrier Aggs' },
  { path: '/analysis/limit-dispersion', label: 'Limit Dispersion' },
];

export const AnalysisSubmenu: React.FC<AnalysisSubmenuProps> = ({ collapsed, onMobileClose }) => {
  const location = useLocation();
  const isAnalysisRoute = location.pathname.startsWith('/analysis');
  const [isOpen, setIsOpen] = useState(isAnalysisRoute);

  useEffect(() => {
    if (isAnalysisRoute) setIsOpen(true);
    else setIsOpen(false);
  }, [isAnalysisRoute]);

  if (collapsed) {
    return (
      <div className="relative">
        <NavLink
          to="/analysis/quotes-outstanding"
          onClick={onMobileClose}
          className={({ isActive }) =>
            clsx(
              'group flex items-center justify-center px-0 py-3 text-white/80 hover:bg-white/10 hover:text-white transition-all duration-200 w-full',
              (isActive || isAnalysisRoute) && 'bg-white/10 text-white border-l-4 border-white/60'
            )
          }
          title="Analysis"
        >
          <ChartBarIcon className="w-5 h-5 mx-auto transition-transform duration-200 group-hover:translate-x-0.5" />
        </NavLink>
      </div>
    );
  }

  return (
    <div>
      <div className={clsx('group flex items-center w-full text-white/80 transition-all duration-200', isAnalysisRoute && 'bg-white/10 text-white')}>
        <NavLink
          to="/analysis/quotes-outstanding"
          onClick={onMobileClose}
          className="flex min-w-0 flex-1 items-center px-4 py-3 hover:bg-white/10 hover:text-white"
        >
          <ChartBarIcon className="w-5 h-5 flex-shrink-0 transition-transform duration-200 group-hover:translate-x-0.5" />
          <span className="ml-3">Analysis</span>
        </NavLink>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="px-4 py-3 hover:bg-white/10 hover:text-white"
          aria-expanded={isOpen}
          aria-haspopup="true"
          aria-label="Toggle Analysis submenu"
        >
          <ChevronDownIcon className={clsx('w-4 h-4 transition-transform duration-200', isOpen && 'rotate-180')} />
        </button>
      </div>

      {isOpen && (
        <div className="mx-4 mb-2 bg-black/20 rounded-lg border border-white/10 overflow-hidden">
          {items.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onMobileClose}
              className={({ isActive }) =>
                clsx(
                  'group flex items-center px-4 py-2.5 text-white/70 hover:bg-white/5 hover:text-white transition-all duration-200',
                  'border-l-2 border-transparent hover:border-white/30',
                  isActive && 'bg-white/10 text-white border-l-2 border-white/60'
                )
              }
            >
              <span className="text-sm">{item.label}</span>
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
};
